import React from 'react'

import BookingConfirmation from '@cinch/oxd-components/booking-confirmation/src'
import { BookResponse, PersonalInformationResponse } from '@cinch/oxd-pages/wbac/src/types'
import Statuses from '@cinch/oxd-utils/request-status/src'

interface Props {
  appointment: BookResponse
  personalInformation: PersonalInformationResponse
}

import useAppointment from './appointment.hook'

// todo put this translations somewhere better
const i18n = {
  openingTimes: 'Opening times',
  contact: 'Contact',
  email: 'Email',
  phone: 'Phone',
  aware: 'Please be aware that calls are recorded for training and monitoring purposes',
  home: 'Back to home',
  valuation: 'Valuation',
  reference: 'Reference Number',
  fee: 'Fee',
  transfer: 'For your peace of mind and convenience, payments will be made via secure bank transfer',
  documents: 'Documents',
  id: 'Your ID',
  finance: 'Finance details',
  about: 'About your valuation',
}

const AppointmentView: React.FC<Props> = ({ appointment, personalInformation }) => {
  const { siteStatus, site } = useAppointment(appointment)
  const { vehiclePriceOffered, valuationId, adminFee } = personalInformation

  return (
    <BookingConfirmation
      isLoading={siteStatus === Statuses.PENDING}
      site={site}
      date={appointment.date}
      timeslot={appointment.startTime}
      valuationAmount={vehiclePriceOffered}
      valuationId={valuationId}
      adminFee={adminFee}
      i18n={i18n}
    />
  )
}

export default AppointmentView
